const NotFound = () => <p>Can't find what you're looking for</p>;

export default NotFound;
